<template>
  <div class="home-page">
    <!-- Section 1: Top Banner -->
    <div class="section-banner">
      <div class="content">
        <h1>全球产业资源<br>价值流通网络</h1>
        <p>我们致力于为用户提供全价值链产业服务<br>解决用户产业升级过程中的效率链接，赋能用户价值成长</p>
        <div class="actions">
          <el-button class="btn-yellow" type="primary" @click="goToUserExperience">立即体验</el-button>
          <el-button class="btn-dark" type="primary">&gt;</el-button>
        </div>
      </div>
    </div>

    <!-- Section 2: Insight Analysis -->
    <div class="section-insight">
      <div class="insight-container">
        <div class="insight-card">
          <h2>{{ activeService.name }}</h2>
          <p>{{ activeService.description }}</p>
        </div>
        <div class="services-card">
          <h3>Services</h3>
          <ul>
            <li v-for="service in services" :key="service.name" :class="{ active: service.active }"
                @click="selectService(service)">
              {{ service.name }} <span v-if="service.active">&nbsp;&lt;&lt;</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Section 3: Industry Parlor -->
    <div class="section-parlor">
      <div class="parlor-content">
        <h2>产业会客厅</h2>
        <p>从全球产业最佳实践的引进、适配、到具体产业环节的数字化平台+新业态场景应用三位一体的模式，为项目、资本、服务、技术、场景和商机等要素多方主体设计
          “展示窗口、对接平台、服务枢纽、创新引擎”，助力产业和都市圈持续发展。我们用心优化中国产业资源流动效率，优化用户体验，创建价值最大化。</p>
        <div class="actions">
          <el-button class="btn-yellow" type="primary" @click="$router.push('/parlor')">了解详情</el-button>
          <el-button class="btn-dark" type="primary" @click="$router.push('/parlor')">&gt;</el-button>
        </div>
      </div>
      <div class="parlor-image">
        <img src="https://echance.oss-cn-beijing.aliyuncs.com/index-bg3.png" alt="Industry Parlor">
      </div>
    </div>

    <!-- Section 4: Industrial Policy -->
    <div class="section-policy">
      <h2>产业政策</h2>
      <div class="policy-grid">
        <div v-for="(item, index) in policyData" :key="index" class="policy-item" @click="viewPolicyDetail(item.id)">
          <h4>{{ item.title }}</h4>
          <p class="policy-desc">{{ stripHtml(item.content) }}</p>
          <p class="date">{{ item.pubtime }}</p>
        </div>
      </div>
      <div class="view-more" @click="$router.push('/policy')">
        查看更多 >
      </div>
    </div>

    <!-- Section 5: Industry Dynamics -->
    <div class="section-dynamics">
      <h2>产业动态</h2>
      <div class="policy-grid">
        <div v-for="(item, index) in dynamicsData" :key="index" class="policy-item" @click="viewNewsDetail(item.id)">
          <h4>{{ item.title }}</h4>
          <p class="policy-desc">{{ stripHtml(item.content) }}</p>
          <p class="date">{{ item.pubtime }}</p>
        </div>
      </div>
      <div class="view-more" @click="$router.push('/news')">
        查看更多 >
      </div>
    </div>
    <div class="section-choice-img">
      <img src="https://echance.oss-cn-beijing.aliyuncs.com/index-bg2.png"/>
    </div>
    <!-- Section 6: Customer Choice -->
    <div class="section-choice">
      <h2>8500+用户的共同选择</h2>
      <div class="tabs-container">
        <el-tabs v-model="activeTab" type="card">
          <el-tab-pane v-for="cat in caseCategories" :key="cat.name" :label="cat.label" :name="cat.name"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="choice-card">
        <el-carousel
            :key="activeTab"
            ref="customerCarousel"
            :interval="5000"
            indicator-position="outside"
            height="450px">
          <el-carousel-item v-for="(item, index) in projectData" :key="index">
            <div class="tab-content">
              <div class="text">
                <h3>{{ item.title }}</h3>
                <!-- 简介来自后台富文本，须去标签后展示，避免整段 HTML 当纯文本露出 -->
                <p>{{ stripHtml(item.introduction, false) }}</p>
              </div>
              <img :src="item.image && item.image.startsWith('http') ? item.image : imgUrl + item.image" v-if="item.image" />
              <div class="image-placeholder" v-else></div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- Section 7: Contact Us -->
    <div class="section-contact">
      <div class="contact-content">
        <h2>开启专属服务<br>获取更大价值</h2>
        <el-form class="contact-form" :model="contactForm" :rules="contactRules" ref="contactForm">
          <el-input v-model="contactForm.name" placeholder="您的姓名"></el-input>
          <el-input v-model="contactForm.mobile" placeholder="手机号码"></el-input>
          <div class="actions">
            <el-button class="btn-yellow" type="primary" @click="submitContactForm">Services</el-button>
            <el-button class="btn-dark" type="primary">&gt;</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { saveUserRequirementApi, getProjectCategoriesApi, getProjectListApi, getPolicyListApi, getIndustryNewsListApi } from '@/api/index';
import {baseImgUrl} from '@/axios/index';

export default {
  name: 'HomePage',
  data() {
    return {
      imgUrl:baseImgUrl,
      policyData: [],
      dynamicsData: [],
      services: [
        {
          name: '洞察分析',
          active: true,
          description: '融合系统性研究框架、多维数据、深度逻辑推理，赋能决策者（企业、投资者、政府）在高度不确定性的环境中，做出更明智、更具前瞻性和竞争力的战略选择。'
        },
        {
          name: '产业咨询',
          active: false,
          description: '对地方政府、园区及企业提供超长期国债、专项债、中央预算内投资、专项资金及大型项目的前期研究和决策以及项目实施和运行（或称运营）的全生命周期工程咨询服务。'
        },
        {
          name: '资源对接',
          active: false,
          description: '我们致力于为用户提供合适的产业资源解决用户寻找所需产业资源面临的效率挑战，助力用户获得成功'
        },
        {
          name: '数字化建设',
          active: false,
          description: '通过人工智能、物联网、大数据等技术重构业务流程，提升产业效率与创新能力。'
        },
        {
          name: '项目孵化',
          active: false,
          description: '为技术商业化、初创企业成长、创新产品落地等新项目提供项目规划、项目建设、项目运营、投融资、人才服务等全生命周期培育服务。'
        }
      ],
      activeTab: '',
      caseCategories: [],
      projectData: [], // 用于存储项目数据
      loading: {
        categories: false,
        projects: false,
        policies: false,
        news: false
      },
      contactForm: {
        name: '',
        mobile: '',
        demandType: '7' // Default demand type
      },
      contactRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 获取项目分类数据
    this.getProjectCategories();
    // 获取产业政策数据
    this.getPolicyData();
    // 获取产业动态数据
    this.getNewsData();
  },
  computed: {
    activeService() {
      return this.services.find(service => service.active) || {};
    }
  },
  watch: {
    // 监听activeTab变化，加载对应分类的项目数据
    activeTab(newVal) {
      if (newVal) {
        this.getProjectList(newVal);
      }
    }
  },
  methods: {
    goToUserExperience() {
      window.open('http://user.yishangji.com.cn/', '_blank');
    },

    selectService(selectedService) {
      this.services.forEach(service => {
        service.active = (service.name === selectedService.name);
      });
    },
    
    // 获取产业政策数据
    async getPolicyData() {
      try {
        this.loading.policies = true;
        // 请求参数设置，获取4条数据
        const params = {
          page: 1,
          limit: 4
        };
        const res = await getPolicyListApi(params);
        
        if (res && res.list) {
          this.policyData = res.list.slice(0, 4); // 确保最多只取4条数据
        }
      } catch (error) {
        console.error('获取产业政策数据出错', error);
        this.$message.error('获取产业政策数据失败');
      } finally {
        this.loading.policies = false;
      }
    },
    
    // 获取产业动态数据
    async getNewsData() {
      try {
        this.loading.news = true;
        // 请求参数设置，获取4条数据
        const params = {
          pageNum: 1,
          pageSize: 4
        };
        const res = await getIndustryNewsListApi(params);
        
        if (res.data && res.data.records) {
          this.dynamicsData = res.data.records.slice(0, 4); // 确保最多只取4条数据
        }
      } catch (error) {
        console.error('获取产业动态数据出错', error);
        this.$message.error('获取产业动态数据失败');
      } finally {
        this.loading.news = false;
      }
    },
    
    // 获取项目分类
    async getProjectCategories() {
      try {
        this.loading.categories = true;
        const res = await getProjectCategoriesApi();
        if (res && res.data) {
          // 转换API返回的数据格式
          this.caseCategories = res.data.map(item => ({
            name: item.code,
            label: item.title
          }));
          
          // 设置默认选中的分类
          if (this.caseCategories.length > 0) {
            this.activeTab = this.caseCategories[0].name;
          }
        }
      } catch (error) {
        console.error('获取项目分类出错', error);
        this.$message.error('获取项目分类失败');
      } finally {
        this.loading.categories = false;
      }
    },
    
    // 获取项目列表
    async getProjectList(contentType) {
      try {
        this.loading.projects = true;
        const params = { contentType };
        const res = await getProjectListApi(params);
        
        if (res && res.data) {
          // 转换API返回的项目数据格式
          this.projectData = res.data.map(item => ({
            title: item.title || '',
            introduction: item.introduction || item.description || item.content || '',
            image: item.coverImg || item.image || ''
          }));
        } else {
          this.projectData = [];
        }
      } catch (error) {
        console.error('获取项目列表出错', error);
        this.$message.error('获取项目列表失败');
        this.projectData = [];
      } finally {
        this.loading.projects = false;
      }
    },
    
    submitContactForm() {
      // 判断姓名和手机号是否为空
      if (!this.contactForm.name || this.contactForm.name.trim() === '') {
        this.$message.error('请输入您的姓名');
        return;
      }
      if (!this.contactForm.mobile || this.contactForm.mobile.trim() === '') {
        this.$message.error('请输入手机号码');
        return;
      }
      
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          saveUserRequirementApi(this.contactForm).then(res => {
            this.$message.success('提交成功');
            this.contactForm.name = '';
            this.contactForm.mobile = '';
          }).catch(err => {
            this.$message.error('提交失败，请稍后重试');
            console.error(err);
          });
        } else {
          return false;
        }
      });
    },
    
    // 查看政策详情
    viewPolicyDetail(id) {
      // 使用window.open在新标签页打开详情页
      const detailUrl = `${window.location.origin}/policy/detail/${id}`;
      window.open(detailUrl, '_blank');
    },
    
    // 查看新闻详情
    viewNewsDetail(id) {
      // 使用window.open在新标签页打开详情页
      const detailUrl = `${window.location.origin}/news/detail/${id}`;
      window.open(detailUrl, '_blank');
    },
    
    /**
     * 去除 HTML 为纯文本
     * @param {string} html
     * @param {number|boolean} maxLen 默认 100；传 false 表示不截断（如首页轮播简介）
     */
    stripHtml(html, maxLen = 100) {
      if (!html) return '';

      // 先移除style标签及其内容
      let result = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

      // 移除所有HTML标签
      result = result.replace(/<\/?[^>]+(>|$)/g, '');

      // 处理HTML实体编码
      result = result.replace(/&nbsp;/g, ' ')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'");

      // 移除多余空白
      result = result.replace(/\s+/g, ' ').trim();

      const limit = maxLen === false ? null : (maxLen === undefined ? 100 : maxLen);
      if (limit != null && limit > 0 && result.length > limit) {
        result = result.substring(0, limit) + '...';
      }

      return result;
    },
  }
}
</script>

<style lang="scss" scoped>

::v-deep .section-choice .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  width: 100%;
  font-size: 18px;
  color: #19456B;
  line-height: 24px;
  text-align: center;
}

::v-deep .section-choice .el-tabs--card > .el-tabs__header .el-tabs__item {
  color: #ffffff !important;
}

::v-deep .section-choice .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  color: #666666 !important;
}

.home-page {
  width: 100%;
  margin: 0 auto;
  background-color: #f5f5f5;
  color: #333;
}

.section-banner,
.section-choice,
.section-contact,
.section-choice-img {
  width: 100%;
}

.content,
.section-insight,
.section-parlor,
.section-policy,
.section-dynamics,
.contact-content {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.section-banner {
  height: 1080px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/index-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  color: #fff;

  .content {
    padding-top: 345px;

    h1 {
      font-weight: bold;
      font-size: 78px;
      line-height: 92px;
      margin-bottom: 30px;
    }

    p {
      font-size: 17px;
      font-weight: bold;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      line-height: 25px;
      margin-bottom: 70px;
    }

    .actions {
      display: flex;

      .btn-yellow {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #0F0FB1;
        width: 150px;
        height: 50px;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
      }

      .btn-dark {
        background-color: #002366;
        border-color: #002366;
        color: #fff;
        width: 50px;
        height: 50px;
        margin-left: -5px;
      }
    }
  }
}

.section-insight {
  width: 1200px;
  margin: -100px auto 110px;
  position: relative;
  z-index: 1;

  .insight-container {
    background-color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    display: flex;
    padding: 40px;
    padding-top: 60px;
    position: relative;
  }

  .insight-card {
    background-color: #F4F8FF;
    padding: 30px;
    width: 70%;
    height: 320px;
    margin-right: 20px;
    align-content: center;

    h2 {
      font-weight: bold;
      font-size: 32px;
      color: #19456B;
      line-height: 24px;
      margin-bottom: 25px;
    }

    p {
      font-size: 17px;
      color: #382933;
      line-height: 25px;
    }
  }

  .services-card {
    background: linear-gradient(135deg, #00008E 0%, #017280 100%);
    color: #fff;
    padding: 30px;
    width: 30%;
    margin-top: -120px;

    h3 {
      font-size: 28px;
      margin-bottom: 40px;
      margin-top: 50px;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 20px;
        font-size: 17px;
        cursor: pointer;
        color: #a9b9d7;

        &.active {
          color: #fff;
        }

        &:hover {
          color: #fff;
        }
      }
    }
  }
}

.section-parlor {
  display: flex;
  width: 1200px;
  margin: 0 auto 100px;
  // align-items: center;

  .parlor-content {
    width: 50%;
    padding-right: 40px;
    margin-top: 50px;

    h2 {
      font-weight: bold;
      font-size: 56px;
      color: #19456B;
      line-height: 66px;
      margin-bottom: 36px;
    }

    p {
      font-size: 17px;
      color: #382933;
      line-height: 25px;
      margin-bottom: 100px;
    }

    .actions {
      display: flex;

      .btn-yellow {
        background-color: #ffc107;
        border-color: #ffc107;
        width: 150px;
        height: 50px;
        font-weight: bold;
        font-size: 20px;
        color: #0F0FB1;
        line-height: 22px;
      }

      .btn-dark {
        background-color: #002366;
        border-color: #002366;
        color: #fff;
        width: 50px;
        height: 50px;
        margin-left: -5px;
      }
    }
  }

  .parlor-image {
    width: 50%;

    img {
      width: 515px;
      height: 615px;
    }
  }
}

.section-policy, .section-dynamics {
  width: 1200px;
  margin: 0 auto 100px;

  h2 {
    font-size: 32px;
    text-align: center;
    margin-bottom: 40px;
    color: #19456B;
  }

  .policy-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    
    .policy-item {
      background-color: #fff;
      padding: 30px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      width: 580px;
      box-sizing: border-box;
      cursor: pointer; /* 添加鼠标指针样式 */
      transition: box-shadow 0.3s ease; /* 添加过渡效果 */
      
      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* 添加悬停效果 */
      }
      
      h4 {
        font-weight: 500;
        font-size: 24px;
        color: #382933;
        line-height: 32px;
        margin-bottom: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      
      .policy-desc {
        font-size: 16px;
        color: #382933;
        line-height: 25px;
        margin-bottom: 15px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      
      .date {
        font-weight: 400;
        font-size: 16px;
        color: #382933;
        line-height: 25px;
      }
    }
  }

  .el-table {
    background-color: transparent;
    border-spacing: 20px;
    border-collapse: separate;

    &::before {
      display: none;
    }

    ::v-deep tr {
      background-color: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      margin-bottom: 20px;
    }

    ::v-deep td {
      border-bottom: none;
      padding: 20px;
    }

    h4 {
      font-size: 18px;
      font-weight: normal;
      margin-bottom: 20px;
      line-height: 1.6;
    }

    .date {
      font-size: 14px;
      color: #999;
    }
  }

  .view-more {
    text-align: center;
    margin-top: 30px;
    color: #19456B;
    cursor: pointer;

    &:hover {
      color: #002366;
    }
  }
}

.section-choice-img {
  width: 100%;
  height: 750px;

  img {
    width: 100%;
  }
}

.section-choice {
  margin: -460px auto 100px;
  position: relative;

  h2 {
    font-size: 32px;
    text-align: center;
    margin-bottom: 85px;
    color: #fff;
  }

  .tabs-container {
    width: 1320px;
    margin: 0 auto;
    margin-bottom: 1px;
  }

  .choice-card {
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    padding: 90px 60px 60px 60px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  ::v-deep .el-tabs--card > .el-tabs__header {
    border-bottom: none;
    margin: 0;
  }

  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
  }

  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: none;
    background: none;
    font-size: 16px;
    color: #666;
    height: 50px;
    line-height: 50px;
    padding: 0 25px !important;

    &.is-active {
      background-color: #ffc107;
      color: #333;
      border-bottom: 1px solid #ffc107;
    }
  }

  ::v-deep .el-tabs__content {
    display: none;
  }

  .tab-content {
    display: flex;
    margin-top: 50px;
    justify-content: space-between;

    .text {
      width: 50%;
      padding-right: 40px;

      h3 {
        font-weight: bold;
        font-size: 56px;
        color: #19456B;
        line-height: 66px;
        margin-bottom: 32px;
      }

      p {
        font-size: 17px;
        color: #382933;
        line-height: 25px;
        color: #666;
      }

      //.dots {
      //  font-size: 24px;
      //  color: #ffc107;
      //  letter-spacing: 4px;
      //  margin-top: 20px;
      //}
    }

    img {
      width: 450px;
      height: 450px;
      object-fit: cover;
    }

    .image-placeholder {
      width: 450px;
      height: 450px;
      background-color: #e9ecef;
    }
  }

  .indicator-squares {
    display: flex;
    margin-top: 40px;

    .square {
      width: 30px;
      height: 30px;
      background-color: #e9ecef;
      margin-right: 15px;
    }
  }
}

.section-contact {
  margin: 0 auto 100px;
  width: 1200px;
  height: 340px;
  box-sizing: border-box;
  padding: 40px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/bg-contact.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  .contact-content {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-weight: bold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 52px;
    }

    .contact-form {
      display: block;

      .el-input {
        width: 350px;
        display: block;
        margin-bottom: 25px;

        ::v-deep .el-input__inner {
          background-color: transparent;
          border: none;
          border-bottom: 2px solid rgba(255, 255, 255, 0.5);
          border-radius: 0;
          padding-left: 0;
          height: 50px;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 24px;

          &:focus {
            border-bottom-color: #fff;
          }

          &::placeholder {
            color: #ccc;
            font-size: 24px;
          }
        }
      }

      .actions {
        display: flex;

        .btn-yellow {
          background-color: #ffc107;
          border-color: #ffc107;
          width: 150px;
          height: 50px;
          font-weight: bold;
          font-size: 20px;
          color: #0F0FB1;
          line-height: 22px;
          border-radius: 0;
        }

        .btn-dark {
          background-color: #002366;
          border-color: #002366;
          color: #fff;
          width: 50px;
          height: 50px;
          margin-left: -1px;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
